import { CategoryModel } from '@/models/categories'
import { api } from '@/services/api'

export { fetchCampaignById } from '@/redux/campaign/sagas/_http/campaign'

type FetchCategoriesByCompanyParams = {
  companyId: string
}

export type FetchCategoriesByCompanyResponse = {
  categories: CategoryModel[]
}

export async function fetchCategoriesByCompanyId(params: FetchCategoriesByCompanyParams) {
  const response = await api.get<FetchCategoriesByCompanyResponse>(`/categories/find-by-company-id/${params.companyId}`)
  return response.data
}
